// extracted by css-extract-rspack-plugin
export default {"button":"TakePictureButton_button__LFvCo"};